import { IP } from "../internalServer"


export default function TicketUi({ data, setDeleteClick, setReOpen, setChoosedTicket, setExpanded, setTicketOpned }) {

    function formatTime(timeString) {
        const time = new Date(timeString);
        let hours = time.getHours();
        const minutes = time.getMinutes();
        const period = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;
        const paddedMinutes = minutes < 10 ? "0" + minutes : minutes;
        return `${hours}:${paddedMinutes} ${period}`;
    }

    return (
        <>
            <div className="query_list_box_ticket_query mt-2" style={{ cursor: "pointer" }} onClick={() => { setExpanded(true); setTicketOpned(true); setChoosedTicket(data) }} >
                <div className="d-flex justify-content-between" >
                    <div className="d-flex">
                        {data?.status === "pending" && <img src="/images/Pending.svg" alt="statusImage" style={{ height: "15px" }} className="mt-2"></img>}
                        {data?.status === "resolved" && <img src="/images/Resolved.svg" alt="statusImage" style={{ height: "15px" }} className="mt-2"></img>}
                        {data?.issue_category === "feature_issue" && <p className="mt-1 ml-3">Feature Issue</p>}
                        {data?.issue_category === "improvisation_feedback" && <p className="mt-1 ml-3">Improvisation or Feedback</p>}

                    </div>
                    <div>
                        <img
                            src={
                                data?.user_id?.profile_picture
                                    ? IP + data.user_id?.profile_picture.replace(/^\./, "")
                                    : data.user_id?.gender === "M"
                                        ? data.user_id?.avatarProfile ? '/images/Boys/' + data.user_id?.avatarProfile + '.webp'
                                            : "/images/Student_boy_pic.png"
                                        : data.user_id?.gender === "F"
                                            ? data.user_id?.avatarProfile ? '/images/Girls/' + data.user_id?.avatarProfile + '.webp'
                                                : "/images/Student_girl_pic.png"
                                            : "/images/default image.png"
                            }
                            alt="icon"
                            className=""
                            style={{ width: "40px", height: "40px", borderRadius: "50%", cursor: "pointer" }}
                            onError={(e) => {
                                if (data.user_id?.gender === "M") {
                                    e.target.src = data.user_id?.avatarProfile ? '/images/Boys/' + data.user_id?.avatarProfile + '.webp' : "/images/Student_boy_pic.png"
                                } else if (data.user_id?.gender === "F") {
                                    e.target.src = data.user_id?.avatarProfile ? '/images/Girls/' + data.user_id?.avatarProfile + '.webp' : "/images/Student_girl_pic.png"
                                } else {
                                    e.target.src = "/images/default image.png"
                                }
                            }}
                        />
                    </div>
                </div>
                <div>
                    <div className="w-full flex justify-between">
                        <p className="mt-1 ml-2 comments-text" style={{ width: "80%", fontSize: "15px", fontWeight: 500 }}>{data?.ticket}</p>
                        <div className="flex items-center">
                            <p className="mt-1 ml-3 flex gap-2" style={{ fontSize: "13px", fontWeight: 400 }}><div>{data?.reply_count}</div> <span>Comments</span></p>
                            <p className="mt-1 ml-3 w-24" style={{ fontSize: "13px", fontWeight: 400 }}>{formatTime(data?.updated_at)}</p>
                        </div>
                    </div>
                </div>
                <div className="W-full">
                    <div className="d-flex justify-content-between items-center">
                        <p className="mt-1 ml-3 comments-text" style={{ width: "80%" }}>{data?.description}</p>
                        {data.status === "pending" && <button
                            style={{ width: "10%" }}
                            className="mt-2 btn btn-light creaeQueryBtn"
                            onClick={(e) => { e.stopPropagation(); setDeleteClick(true); setChoosedTicket(data) }}
                        >
                            Delete
                        </button>}
                        {data.status === "resolved" && <button
                            style={{ width: "10%" }}
                            className="mt-2 btn btn-light creaeQueryBtn"
                            onClick={() => { setReOpen(true); setChoosedTicket(data) }}
                        >
                            Re-Open
                        </button>}
                    </div>
                </div>
            </div>
        </>
    )
}

